export const headerConfig = {
  headerTitle: "Payment Transaction",
  headerDescription: "List of payment Transaction.",
  refreshButton: {
    id: 'refresh',
    label: 'Refresh',
    icon: 'RefreshIcon',
  },
};
